<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">累计佣金</div>
          <div class="money">
            ￥<span class="num">{{ user.total_money }}</span>
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sign-record" ref="content">
      <div class="list">
        <div class="header th">
          <div class="td name">购买人</div>

          <div class="td">一级</div>
          <div class="td">二级</div>

          <div class="td">状态</div>
          <div class="td time">时间</div>
        </div>
        <div class="item th" v-for="(item, index) in info" :key="index">
          <div class="td name">
            <img
              class="logo"
              v-if="item.pay_user_avatar"
              :src="item.pay_user_avatar"
            />
            <img class="logo" v-else src="@assets/images/writeOff.jpg" />
          </div>
          <div :class="['td', item.parent_id == user.id ? 'me' : '']">
            {{ item.parent_id == user.id ? "+" : ""
            }}{{ item.parent_commission }}
          </div>
          <div :class="['td', item.parents_id == user.id ? 'me' : '']">
            {{ item.parents_id == user.id ? "+" : ""
            }}{{ item.parents_commission }}
          </div>
          <div class="td">
            {{ item.commission_status ? "已入账" : "为入账" }}
          </div>
          <div class="td time">
            {{ item.pay_time }}
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
.list .header {
  background: #cccccc;
  padding: 0.25rem 0;
}
.th {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.list .td {
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  box-sizing: content-box;
}
.list .name {
  max-width: 1rem;
  display: flex;
  align-items: center;
  padding: 0;
}
.logo {
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 100%;
  margin-right: 0.1rem;
}
.list .time {
  width: 2rem;
  text-align: right;
  color: #999999;
}
.list .item .td {
  padding: 0.2rem;
}
.list .item .me {
  color: red;
}
</style>
<script>
import { getBalance, getSpreadInfo } from "../../../api/user";
import Loading from "@components/Loading";

export default {
  name: "CommissionDetails",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      info: [],
      user: {},
      where: {
        page: 1,
        page_size: 20
      },
      types: 3,
      loaded: false,
      loading: false
    };
  },
  mounted: function() {
    this.getCommission();
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getSpreadInfo(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.page_size;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data);
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },
    getCommission: function() {
      let that = this;
      getBalance().then(
        res => {
          that.user = res.data;
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
